// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__D3bcy","overflowing":"ReadFullNote_overflowing__3OFr1"};